import React from "react"
import { useTranslation } from "react-i18next"
import Select from "react-select"

const SelectField = ({ options, onChange, field, form, inputProps }) => {
  const { t } = useTranslation()

  return (
    <Select
      isClearable
      options={options}
      name={field.name}
      value={
        options ? options.find(option => option.value === field.value) : ""
      }
      placeholder={t("select.placeholder")}
      noOptionsMessage={() => t("select.noOptionsMessage")}
      onChange={option => {
        const newValue = !inputProps?.isMulti
          ? option?.value
          : inputProps.isMulti && option !== null
          ? option.map(item => item.value)
          : []

        form?.setFieldValue(field.name, newValue)

        if (onChange) {
          onChange(newValue)
        }
      }}
      onBlur={field.onBlur}
      {...inputProps}
    />
  )
}
export { SelectField as Select }
